import React, { useEffect, useState } from "react";
import {
  useGetListeningPart,
  useGetListening,
  useUpdateUserListeningAnswers,
} from "../../services";
import QuestionSet from "../common/QuestionSet";
import TopBar from "../layout/TopBar";
import NavigationBar from "../navigation-bar";
import { useExam } from "../../context/ExamContext";
import { section } from "framer-motion/client";
import TextHighlighter from "../../utils/textHighlighter";
import Header from "../layout/Header";
import { useExamServerDataOperations } from "../../hooks/useExamServerDataOperations";

const Listening = ({ onDropAnswer, onReturnAnswer }) => {
  const { listening } = useGetListening();
  const { listeningPart, isLoadingListeningTest } = useGetListeningPart();
  const [inputs, setInputs] = useState({});
  const updateBulkData = useUpdateUserListeningAnswers();
  const [availableOptions, setAvailableOptions] = useState([]);
  const { answers } = useExam();
  useExamServerDataOperations();

  useEffect(() => {
    if (answers && answers.length > 0) {
      const prefilledInputs = {};
      answers.forEach(({ questionNumber, answer }) => {
        prefilledInputs[questionNumber] = answer;
      });
      setInputs(prefilledInputs);
    }
  }, [answers]);

  return (
    <section>
      <Header />

      <div className="p-3 h-[calc(100vh-116px)]">
        <TopBar
          section={section}
          instruction={listeningPart?.instructionLabel || ""}
          unit={listeningPart?.part}
        />
        <TextHighlighter
          docId={"listening-" + (listeningPart?.part || "0") + "-questions"}
        >
          {listeningPart ? (
            <div className="p-2 items-center">
              <div className="questions-section questions-section-listening">
                <div data-block-id={"question-" + (listeningPart?.part || "0")}>
                  {listeningPart?.questionSets?.map((set, index) => (
                    <QuestionSet
                      key={index}
                      index={index}
                      set={set}
                      onDropAnswer={onDropAnswer}
                      onReturnAnswer={onReturnAnswer}
                      availableOptions={availableOptions}
                      setAvailableOptions={setAvailableOptions}
                    />
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div>There is not any question!</div>
          )}
        </TextHighlighter>
      </div>

      <NavigationBar
        sectionData={listening}
        section="listening"
        stageQuestionInterval={listeningPart.totalQuestionInterval || ""}
        updateBulkData={updateBulkData}
      />
    </section>
  );
};

export default Listening;
